import './index.less'

import PropTypes from 'ant-design-vue/es/_util/vue-types'
import { isArray } from 'ant-design-vue/es/_util/util'
import GridContent from '../GridContent'
import 'ant-design-vue/es/page-header/style'
import PageHeader from 'ant-design-vue/es/page-header'
import { pageHeaderProps } from 'ant-design-vue/es/page-header'
import 'ant-design-vue/es/tabs/style'
import Tabs from 'ant-design-vue/es/tabs'
import { getComponentFromProp } from '../../utils/util'
import { RouterLink } from 'vue-router'
import * as Vue from 'vue'

const prefixedClassName = 'ant-pro-page-header-wrap'

const PageHeaderTabConfig = {
  tabList: PropTypes.array,
  tabActiveKey: PropTypes.string,
  tabProps: PropTypes.object,
  tabChange: PropTypes.func
}

const PageHeaderWrapperProps = {
  ...PageHeaderTabConfig,
  ...pageHeaderProps,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  content: PropTypes.any,
  extraContent: PropTypes.any,
  pageHeaderRender: PropTypes.func,
  breadcrumb: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).def(true),
  back: PropTypes.func,

  // only use `pro-layout` in children
  i18nRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).def(false)
}

const defaultI18nRender = (t) => t

const useContext = (route) => {
  return route && {
    ...route.meta
  } || null
}

const noop = () => {
}

// TODO :: tabList tab 支持图标 优化
const renderFooter = (h, tabConfigProps, i18nRender) => {
  const {
    tabList,
    tabActiveKey,
    tabChange: onTabChange,
    tabBarExtraContent,
    tabProps
  } = tabConfigProps
  // 确保 tabList 是数组，防止 undefined 错误
  const safeTabList = Array.isArray(tabList) ? tabList : []
  return safeTabList.length > 0 && (
    <Tabs
      class={`${prefixedClassName}-tabs`}
      activeKey={tabActiveKey}
      onChange={key => {
        if (onTabChange) {
          onTabChange(key)
        }
      }}
      tabBarExtraContent={tabBarExtraContent}
      {...tabProps}
    >
      {safeTabList.map(item => (
        <Tabs.TabPane {...item} tab={i18nRender(item.tab)} key={item.key}/>
      ))}
    </Tabs>
  )
}

const renderPageHeader = (h, content, extraContent) => {
  if (!content && !extraContent) {
    return null
  }
  return (
    <div class={`${prefixedClassName}-detail`}>
      <div class={`${prefixedClassName}-main`}>
        <div class={`${prefixedClassName}-row`}>
          {content && (
            <div class={`${prefixedClassName}-content`}>{content}</div>
          )}
          {extraContent && (
            <div class={`${prefixedClassName}-extraContent`}>
              {extraContent}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const defaultPageHeaderRender = (h, props, pageMeta, i18nRender) => {
  const {
    title: propTitle,
    tags,
    content,
    pageHeaderRender,
    extra,
    extraContent,
    breadcrumb,
    back: handleBack,
    ...restProps
  } = props
  if (pageHeaderRender) {
    return pageHeaderRender({ ...props })
  }
  let pageHeaderTitle = propTitle
  if (!propTitle && propTitle !== false) {
    // pageHeaderTitle = pageMeta.title
    // 2021.02.03 去除title显示
    pageHeaderTitle = undefined
  }
  // title props 不是 false 且不是 array 则直接渲染 title
  // 反之认为是 VNode, 作为 render 参数直接传入到 PageHeader
  const title = isArray(pageHeaderTitle)
    ? pageHeaderTitle
    : pageHeaderTitle && i18nRender(pageHeaderTitle)
  const tabProps = {
    breadcrumb,
    extra,
    tags,
    title,
    footer: renderFooter(h, restProps, i18nRender)
  }
  if (!handleBack) {
    tabProps.backIcon = false
  }

  return (
    <PageHeader {...{ props: tabProps }} onBack={handleBack || noop}>
      {renderPageHeader(h, content, extraContent)}
    </PageHeader>
  )
  // return
}

const PageHeaderWrapper = {
  name: 'PageHeaderWrapper',
  props: PageHeaderWrapperProps,
  inject: {
    locale: { default: () => null },
    contentWidth: { default: () => 'Fluid' },
    breadcrumbRender: { default: () => null }
  },
  render() {
    const h = Vue.h
    // Vue 3: 安全获取路由信息
    // 尝试从多个来源获取路由信息
    let currentRoute = null
    try {
      currentRoute = this.$props.route || (this.$route || null)
      // 如果仍然没有，尝试从全局路由实例获取
      if (!currentRoute && window.$router) {
        const route = window.$router.currentRoute?.value || window.$router.currentRoute
        if (route) {
          currentRoute = route
        }
      }
    } catch (error) {
      console.warn('PageHeaderWrapper: 获取路由信息失败', error)
      currentRoute = null
    }
    const pageMeta = useContext(currentRoute)
    
    // Vue 3: $slots.default 是函数，需要调用
    const defaultSlot = this.$slots.default
    const children = defaultSlot ? defaultSlot() : null
    
    // 调试日志
    console.log('PageHeaderWrapper: render', {
      hasDefaultSlot: !!defaultSlot,
      childrenType: typeof children,
      childrenIsArray: Array.isArray(children),
      childrenLength: Array.isArray(children) ? children.length : (children ? 'not array' : 'null'),
      childrenValue: children
    })
    
    // Vue 3: 使用 getComponentFromProp 时传入正确的实例对象
    const instance = { props: this.$props, slots: this.$slots, attrs: this.$attrs }
    const title = getComponentFromProp(instance, 'title')
    const tags = getComponentFromProp(instance, 'tags')
    const content = getComponentFromProp(instance, 'content')
    const extra = getComponentFromProp(instance, 'extra')
    const extraContent = getComponentFromProp(instance, 'extraContent')

    const i18n = this.$props.i18nRender || this.locale || defaultI18nRender
    // Vue 3: contentWidth 不能是 false，应该是字符串
    const injectedContentWidth = this.contentWidth || 'Fluid'
    const contentWidth = this.$props.contentWidth || injectedContentWidth
    
    // Vue 3: 不再使用 $listeners，直接使用 props 或 attrs.onBack
    const onBack = this.$props.back || (this.$attrs && this.$attrs.onBack)
    const back = onBack && (() => {
      if (typeof onBack === 'function') {
        onBack()
      } else if (this.$emit) {
        this.$emit('back')
      }
    }) || undefined

    const onTabChange = this.$props.tabChange
    const tabChange = (key) => {
      if (this.$emit) {
        this.$emit('tabChange', key)
      }
      onTabChange && onTabChange(key)
    }

    let breadcrumb = {}
    const propsBreadcrumb = this.$props.breadcrumb
    if (propsBreadcrumb === true) {
      // 安全获取路由匹配信息
      let routes = []
      if (currentRoute && currentRoute.matched && Array.isArray(currentRoute.matched)) {
        routes = currentRoute.matched.concat().filter(route => route && route.meta && route.meta.title)
      }
      routes = routes.map(route => {
        if (route && route.meta && route.meta.title) {
          return {
            path: route.path,
            breadcrumbName: i18n(route.meta.title),
            redirect: route.redirect
          }
        }
        return null
      }).filter(Boolean) // 过滤掉 null 值
      
      const defaultItemRender = ({ route, params, routes, paths }) => {
        // 添加安全检查
        if (!route) {
          return null
        }
        return (route.redirect === 'noRedirect' || (routes && routes.indexOf(route) === routes.length - 1)) && (
          <span>{route.breadcrumbName}</span>
        ) || (
          <RouterLink to={route.path || '/'}>{route.breadcrumbName}</RouterLink>
        )
      }

      // If custom breadcrumb render undefined
      // use default breadcrumb..
      const itemRender = this.breadcrumbRender || defaultItemRender

      breadcrumb = { props: { routes, itemRender } }
    } else {
      breadcrumb = propsBreadcrumb || null
    }

    const props = {
      ...this.$props,
      title,
      tags,
      content,
      extra,
      extraContent,
      breadcrumb,
      tabChange,
      back
    }

    // 确保 children 始终被渲染
    const childrenContent = children ? (Array.isArray(children) ? children : [children]) : []
    
    console.log('PageHeaderWrapper: 准备渲染', {
      hasChildren: !!children,
      childrenContentLength: childrenContent.length,
      contentWidth: contentWidth,
      hasCurrentRoute: !!currentRoute
    })
    
    // 简化渲染：直接渲染 children，不经过 GridContent 嵌套
    // 这样可以避免插槽传递问题
    let pageHeader = null
    try {
      pageHeader = defaultPageHeaderRender(h, props, pageMeta, i18n)
    } catch (error) {
      console.error('PageHeaderWrapper: 渲染 pageHeader 失败', error)
      // 如果渲染失败，返回 null，只渲染 children
    }
    
    return (
      <div class="ant-pro-page-header-wrap">
        {pageHeader && (
          <div class={`${prefixedClassName}-page-header-warp`}>
            {pageHeader}
          </div>
        )}
        {children && childrenContent.length > 0 && (
          <div class={`${prefixedClassName}-children-content`}>
            {childrenContent}
          </div>
        )}
      </div>
    )
  }
}

PageHeaderWrapper.install = function (Vue) {
  Vue.component(PageHeaderWrapper.name, PageHeaderWrapper)
  Vue.component('page-container', PageHeaderWrapper)
}

export default PageHeaderWrapper
